
import { MutableRefObject } from "react";
import Slider, { CustomArrowProps } from "react-slick";

export const CustomPrevArrow = (props: CustomArrowProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="45"
        viewBox="0 0 30 30"
        fill="none"
        className="prev"
        {...props}
        onClick={(e) => {e.stopPropagation();props.onClick(e)}}
        >
        <g
            clip-path="url(#clip0_491_452)"
            filter="url(#filter0_b_491_452)">
            <g filter="url(#filter1_b_491_452)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 0C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10C0 4.47715 4.47715 0 10 0H20ZM15.7482 29.0747C15.7439 29.0725 15.7388 29.0729 15.7341 29.0738C15.7297 29.0746 15.7255 29.076 15.7215 29.0779L15.6468 29.1148C15.6414 29.1174 15.6358 29.1193 15.63 29.1205L15.6268 29.1211C15.6182 29.1229 15.6094 29.1225 15.601 29.1201C15.5978 29.1192 15.5948 29.118 15.5918 29.1166L15.5075 29.075C15.4977 29.0711 15.4887 29.0725 15.4823 29.0769C15.4787 29.0793 15.4767 29.0833 15.4751 29.0872C15.4734 29.0915 15.4724 29.0961 15.4722 29.1008L15.4517 29.6183C15.4514 29.6252 15.4521 29.6322 15.4538 29.6389L15.4546 29.6422C15.4565 29.6498 15.46 29.657 15.4648 29.6632C15.4682 29.6677 15.4724 29.6717 15.477 29.675L15.594 29.7583C15.598 29.7611 15.6024 29.7631 15.6071 29.7644L15.6086 29.7648C15.6152 29.7666 15.6222 29.7663 15.6288 29.7642C15.6321 29.7631 15.6352 29.7615 15.638 29.7594L15.7551 29.6762C15.7608 29.6721 15.7659 29.6671 15.7702 29.6615L15.7708 29.6606C15.776 29.6536 15.7798 29.6456 15.7818 29.6371C15.7831 29.6316 15.7836 29.6259 15.7834 29.6201L15.7629 29.1062C15.7626 29.0987 15.7624 29.091 15.7585 29.0846C15.7559 29.0802 15.7523 29.0767 15.7482 29.0747ZM16.0806 28.9342C16.0756 28.9314 16.0696 28.9317 16.0639 28.9326C16.0588 28.9334 16.0539 28.9349 16.0493 28.9372L15.831 29.047C15.827 29.049 15.8234 29.0516 15.8203 29.0547L15.8189 29.0561C15.8147 29.0603 15.8117 29.0655 15.8101 29.0712C15.8092 29.0745 15.8088 29.078 15.809 29.0815L15.831 29.6067C15.8312 29.6114 15.8322 29.616 15.834 29.6203L15.8343 29.6212C15.8364 29.6262 15.8396 29.6306 15.8437 29.6342C15.8462 29.6364 15.8491 29.6382 15.8521 29.6396L16.0987 29.7537C16.1099 29.7575 16.1204 29.7556 16.1282 29.7503C16.1333 29.7467 16.1359 29.7406 16.1376 29.7346C16.1392 29.7291 16.1398 29.7233 16.1395 29.7176L16.0983 28.9725C16.0978 28.9634 16.0971 28.9539 16.0924 28.946C16.0894 28.9408 16.0854 28.9368 16.0806 28.9342ZM15.1787 28.9338C15.1731 28.9312 15.1667 28.9305 15.1606 28.9319C15.1574 28.9326 15.1544 28.9338 15.1517 28.9355C15.1467 28.9386 15.1438 28.944 15.1415 28.9494C15.1389 28.9556 15.1373 28.9622 15.1369 28.969L15.095 29.7262C15.095 29.7366 15.0992 29.7446 15.1059 29.7502C15.112 29.7552 15.1203 29.7557 15.1281 29.7547C15.1327 29.7541 15.1371 29.7528 15.1413 29.7508L15.3819 29.6395C15.3848 29.6382 15.3875 29.6365 15.39 29.6345L15.3914 29.6334C15.3962 29.6295 15.3999 29.6244 15.402 29.6187C15.4031 29.6154 15.4038 29.612 15.404 29.6085L15.4248 29.0815C15.4249 29.078 15.4246 29.0745 15.4237 29.0711C15.4221 29.0647 15.4188 29.0588 15.414 29.054L15.4134 29.0534C15.4103 29.0503 15.4068 29.0478 15.4029 29.0458L15.1787 28.9338Z"
                    fill="#FDFDFE"
                    fill-opacity="0.9"
                />
            </g>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.366 15.8834C10.1316 15.649 10 15.3312 10 14.9997C10 14.6682 10.1316 14.3504 10.366 14.1159L17.4372 7.0447C17.5525 6.92531 17.6905 6.83008 17.843 6.76457C17.9955 6.69906 18.1595 6.66458 18.3255 6.66313C18.4915 6.66169 18.6561 6.69332 18.8097 6.75617C18.9633 6.81902 19.1029 6.91184 19.2202 7.0292C19.3376 7.14657 19.4304 7.28613 19.4933 7.43975C19.5561 7.59337 19.5877 7.75797 19.5863 7.92395C19.5849 8.08992 19.5504 8.25395 19.4849 8.40645C19.4193 8.55896 19.3241 8.69689 19.2047 8.8122L13.0172 14.9997L19.2047 21.1872C19.4324 21.423 19.5584 21.7387 19.5556 22.0664C19.5527 22.3942 19.4213 22.7077 19.1895 22.9395C18.9577 23.1712 18.6442 23.3027 18.3165 23.3055C17.9887 23.3084 17.673 23.1824 17.4372 22.9547L10.366 15.8834Z"
                fill="#2C3647"
                id="card-arrows"
            />
        </g>
        <defs>
            <filter
                id="filter0_b_491_452"
                x="-2"
                y="-2"
                width="34"
                height="34"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="1"
                />
                <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_491_452"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_491_452"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_b_491_452"
                x="-10"
                y="-10"
                width="50"
                height="50"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="5"
                />
                <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_491_452"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_491_452"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_491_452">
                <rect
                    width="30"
                    height="30"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

export const CustomNextArrow = (props: CustomArrowProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        className="next"
        {...props}
        onClick={(e) => { e.stopPropagation(); props.onClick(e) }}
        >
        <g
            clip-path="url(#clip0_491_456)"
            filter="url(#filter0_b_491_456)">
            <g filter="url(#filter1_b_491_456)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 0C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10C0 4.47715 4.47715 0 10 0H20ZM15.7482 29.0747C15.7439 29.0725 15.7388 29.0729 15.7341 29.0738C15.7297 29.0746 15.7255 29.076 15.7215 29.0779L15.6468 29.1148C15.6414 29.1174 15.6358 29.1193 15.63 29.1205L15.6268 29.1211C15.6182 29.1229 15.6094 29.1225 15.601 29.1201C15.5978 29.1192 15.5948 29.118 15.5918 29.1166L15.5075 29.075C15.4977 29.0711 15.4887 29.0725 15.4823 29.0769C15.4787 29.0793 15.4767 29.0833 15.4751 29.0872C15.4734 29.0915 15.4724 29.0961 15.4722 29.1008L15.4517 29.6183C15.4514 29.6252 15.4521 29.6322 15.4538 29.6389L15.4546 29.6422C15.4565 29.6498 15.46 29.657 15.4648 29.6632C15.4682 29.6677 15.4724 29.6717 15.477 29.675L15.594 29.7583C15.598 29.7611 15.6024 29.7631 15.6071 29.7644L15.6086 29.7648C15.6152 29.7666 15.6222 29.7663 15.6288 29.7642C15.6321 29.7631 15.6352 29.7615 15.638 29.7594L15.7551 29.6762C15.7608 29.6721 15.7659 29.6671 15.7702 29.6615L15.7708 29.6606C15.776 29.6536 15.7798 29.6456 15.7818 29.6371C15.7831 29.6316 15.7836 29.6259 15.7834 29.6201L15.7629 29.1062C15.7626 29.0987 15.7624 29.091 15.7585 29.0846C15.7559 29.0802 15.7523 29.0767 15.7482 29.0747ZM16.0806 28.9342C16.0756 28.9314 16.0696 28.9317 16.0639 28.9326C16.0588 28.9334 16.0539 28.9349 16.0493 28.9372L15.831 29.047C15.827 29.049 15.8234 29.0516 15.8203 29.0547L15.8189 29.0561C15.8147 29.0603 15.8117 29.0655 15.8101 29.0712C15.8092 29.0745 15.8088 29.078 15.809 29.0815L15.831 29.6067C15.8312 29.6114 15.8322 29.616 15.834 29.6203L15.8343 29.6212C15.8364 29.6262 15.8396 29.6306 15.8437 29.6342C15.8462 29.6364 15.8491 29.6382 15.8521 29.6396L16.0987 29.7537C16.1099 29.7575 16.1204 29.7556 16.1282 29.7503C16.1333 29.7467 16.1359 29.7406 16.1376 29.7346C16.1392 29.7291 16.1398 29.7233 16.1395 29.7176L16.0983 28.9725C16.0978 28.9634 16.0971 28.9539 16.0924 28.946C16.0894 28.9408 16.0854 28.9368 16.0806 28.9342ZM15.1787 28.9338C15.1731 28.9312 15.1667 28.9305 15.1606 28.9319C15.1574 28.9326 15.1544 28.9338 15.1517 28.9355C15.1467 28.9386 15.1438 28.944 15.1415 28.9494C15.1389 28.9556 15.1373 28.9622 15.1369 28.969L15.095 29.7262C15.095 29.7366 15.0992 29.7446 15.1059 29.7502C15.112 29.7552 15.1203 29.7557 15.1281 29.7547C15.1327 29.7541 15.1371 29.7528 15.1413 29.7508L15.3819 29.6395C15.3848 29.6382 15.3875 29.6365 15.39 29.6345L15.3914 29.6334C15.3962 29.6295 15.3999 29.6244 15.402 29.6187C15.4031 29.6154 15.4038 29.612 15.404 29.6085L15.4248 29.0815C15.4249 29.078 15.4246 29.0745 15.4237 29.0711C15.4221 29.0647 15.4188 29.0588 15.414 29.054L15.4134 29.0534C15.4103 29.0503 15.4068 29.0478 15.4029 29.0458L15.1787 28.9338Z"
                    fill="#FDFDFE"
                    fill-opacity="0.9"
                />
            </g>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.6344 14.1165C19.8688 14.3509 20.0004 14.6688 20.0004 15.0002C20.0004 15.3317 19.8688 15.6496 19.6344 15.884L12.5632 22.9552C12.4479 23.0746 12.3099 23.1698 12.1574 23.2354C12.0049 23.3009 11.8409 23.3353 11.6749 23.3368C11.509 23.3382 11.3444 23.3066 11.1907 23.2438C11.0371 23.1809 10.8975 23.0881 10.7802 22.9707C10.6628 22.8534 10.57 22.7138 10.5071 22.5602C10.4443 22.4065 10.4127 22.2419 10.4141 22.076C10.4156 21.91 10.45 21.746 10.5155 21.5935C10.5811 21.441 10.6763 21.303 10.7957 21.1877L16.9832 15.0002L10.7957 8.81273C10.568 8.57697 10.442 8.26122 10.4448 7.93347C10.4477 7.60573 10.5791 7.29221 10.8109 7.06045C11.0427 6.82869 11.3562 6.69723 11.6839 6.69438C12.0117 6.69154 12.3274 6.81753 12.5632 7.04523L19.6344 14.1165Z"
                fill="#2C3647"
                id="card-arrows"
            />
        </g>
        <defs>
            <filter
                id="filter0_b_491_456"
                x="-2"
                y="-2"
                width="34"
                height="34"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="1"
                />
                <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_491_456"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_491_456"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_b_491_456"
                x="-10"
                y="-10"
                width="50"
                height="50"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="5"
                />
                <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_491_456"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_491_456"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_491_456">
                <rect
                    width="30"
                    height="30"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

export const handlePrevious = (sliderRef: MutableRefObject<Slider | null>):void => {
    sliderRef.current.slickPrev();
};

export const handleNext = (sliderRef: MutableRefObject<Slider | null>): void => {
    sliderRef.current.slickNext();
};